module.exports = __webpack_public_path__ + "img/psxqkrx37h35f6zbsmdilckq0kfuuwll08eac31c7a-8003-4f47-9c64-4f6e5bf8ce68.7ae773a3.png";